import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';
import { validateResourceUrl } from '../utils/validation.js';

export interface VolcesSeedream45I2iParams {
  /** 文本提示词，用于描述融合后的图片内容 */
  prompt: string;
  /** 输入图片列表，支持 URL 地址或 Base64 编码的图片数据（必须为列表格式，至少2张，最多14张图片） */
  image: string[];
  /** 图片尺寸，例如："2K"、"1024x1024" 等 */
  size?: string;
  /** 是否添加水印，默认值为 false */
  watermark?: boolean;
  /** 响应格式，可选值："url" 或 "b64_json"，默认值为 "url" */
  response_format?: 'url' | 'b64_json';
  /** 提示词优化选项 */
  optimize_prompt_options?: any;
}

export interface VolcesSeedream45I2iResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
}

/**
 * Volces Seedream 4.5 Multi-Image Fusion
 *
 * 支持多张图片融合（2-14张），生成融合后的单张图片
 *
 * API Documentation: https://docs.byteplus.com/en/docs/ModelArk/1541523
 * @param params 请求参数
 * @returns 生成的资源列表
 */
export async function volcesSeedream45I2i(
  params: VolcesSeedream45I2iParams,
): Promise<VolcesSeedream45I2iResource[]> {
  const client = await getClient();

  // 该 API 的特定轮询配置
  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_seedream_4_5',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSeedream45I2iResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          // Validate URL before adding to results
          validateResourceUrl(resource, 'image');

          resources.push({
            type: resource.type || 'image',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
          });
        }
      }
    }
  }

  return resources;
}
